import {useCallback, useEffect, useReducer} from "react";
import {TopicsContextDispatchMessageType} from "./TopicsContext.interfaces";
import {initialState, reducer} from "./TopicsContext.reducer";
import TopicApi from "../../apis/topicApi";
import {ITeamsContext} from "../TeamsContext/TeamsContext.interfaces";
import {ITopic} from "../../Interfaces/Topic";

export const useTopicsContext = (teamsContext: ITeamsContext) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(function onMount() {
        if (!teamsContext.loaded) return;
        (fetchAllTopics)();
    }, [teamsContext.loaded]);

    const fetchAllTopics = useCallback(async () => {
        const topics = await TopicApi.getAllTopics();
        dispatch([
            {type: TopicsContextDispatchMessageType.SetList, list: topics},
            {type: TopicsContextDispatchMessageType.SetLoaded, value: true}
        ]);
    }, []);

    const addUpdateTopic = useCallback((topic: ITopic): Promise<ITopic> => {
        return new Promise<ITopic>(async resolve => {
            if (!topic.id) {
                const addedTopic = await TopicApi.addTopic(topic);
                topic.id = addedTopic.id;
            } else await TopicApi.updateTopic(topic);
            dispatch([{type: TopicsContextDispatchMessageType.AddUpdateTopic, topic}]);
            resolve(topic);
        })
    }, []);

    const deleteTopic = useCallback((id: string): Promise<void> => {
        return new Promise<void>(async resolve => {
            dispatch([{type: TopicsContextDispatchMessageType.DeleteTopic, id: id}]);
            resolve();
            await TopicApi.deleteTopic(id);
        })
    }, []);

    return {
        ...state,
        addUpdateTopic,
        deleteTopic
    }
}